import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { appActions, appSelectors } from 'redux/ducks/app';
var useExpandRow = function (_a) {
    var _b = _a === void 0 ? {} : _a, trackAAFunction = _b.trackAAFunction, _c = _b.isStore, isStore = _c === void 0 ? true : _c;
    var dispatch = useDispatch();
    var toggleExpandRowId = useSelector(appSelectors.getToggleExpandRowId);
    var _d = useState([]), expandedRows = _d[0], setExpandedRows = _d[1];
    var handleExpandRow = function (selectedId) {
        if (isStore) {
            dispatch(appActions.setSelectedExpandRowId(selectedId));
        }
        if (trackAAFunction) {
            trackAAFunction(selectedId);
        }
        var currentExpandedRows = expandedRows;
        var isRowExpanded = currentExpandedRows.includes(selectedId);
        var newExpandedRows = isRowExpanded ? currentExpandedRows.filter(function (id) { return id !== selectedId; }) : currentExpandedRows.concat(selectedId);
        setExpandedRows(newExpandedRows);
    };
    var isRowExpanded = function (selectedId) {
        return expandedRows.includes(selectedId);
    };
    useEffect(function () {
        if (toggleExpandRowId && isStore) {
            handleExpandRow(toggleExpandRowId);
        }
    }, [toggleExpandRowId]);
    return { expandedRows: expandedRows, handleExpandRow: handleExpandRow, isRowExpanded: isRowExpanded };
};
export default useExpandRow;
